// Native
import { useState } from "react"
import { Badge, Button, DialogBody, Grid, GridItem, HStack, Stack, Text, useDisclosure } from "@chakra-ui/react"
import moment from "moment"
import { useQueryClient } from "@tanstack/react-query"

// Custom
import { Parts, UI } from "components"
import { API, toaster, Styles } from "config"

export default function Pay({ data = {}, ...props}){

    const { order, transaction } = data
    const queryClient = useQueryClient()
    const [ error, setError ] = useState(false)
    const [ loading, setLoading ] = useState(false) 
    const code = useDisclosure()

    const status = Styles.orderStatus(order?.status)

    const handleActivate = async (security_code) => {
        setLoading(true)

        try{
            await API.post(`/third/${order.cod}`, { security_code })
            toaster.create({ title: 'O consultor foi ativado com sucesso!', type: 'success' })
            queryClient.invalidateQueries('user')
            queryClient.invalidateQueries('bonus-list')
            props.onClose()
            setLoading(false)
        }catch(err){
            setError(err?.response?.data?.message)
            toaster.create({ title: 'Não foi possível realizar a ativação.', description: err?.response?.data?.message, type: 'warning' })
            setLoading(false)
        }
    }

    return(
    <>
    <Parts.Dialog.SecurityCode.Check {...code} onSuccess={handleActivate}  />
    <UI.Dialog title={`Pagar pedido #${order?.cod}`} loading={loading} {...props}>
        <DialogBody>
            <Stack gap={4}>

                <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                    
                    <GridItem>
                        <Text color="GrayText">Status:</Text>
                        <Badge size="lg" colorPalette={status.colorPalette}>{order?.status_label}</Badge>
                    </GridItem>

                    <GridItem>
                        <Text color="GrayText">Valor:</Text>
                        <Text fontSize="md" fontWeight="bold"><UI.Number.Amount value={transaction?.amount} /></Text>
                    </GridItem>

                    <GridItem colSpan={2}>
                        <Text color="GrayText">Consultor:</Text>
                        <HStack>
                            <UI.Avatar size="xs" name={order?.consultant?.customer?.name} />
                            <Text fontSize="md" fontWeight="bold">{order?.consultant?.customer?.name}</Text>
                        </HStack>
                    </GridItem>

                    <GridItem>
                        <Text color="GrayText">Data do pedido:</Text>
                        <Text>{moment(order?.created_at).format('LLL')}</Text>
                    </GridItem>

                </Grid>
                
                <Button size="lg" colorPalette="blue" loading={loading} loadingText="Realizando pagamento..." onClick={code.onOpen}><UI.Icon name="bonus" /> Realizar pagamento</Button>

            </Stack>

        </DialogBody>
    </UI.Dialog>
    </>
    )
}